import {
  diagram as originalDiagram,
  related,
  sourceIds,
} from './puzzles__atlantis-restaurant-downtown.mdx';

export { sourceIds, related };

export const diagram = {
  ...originalDiagram,
  src: '/diagrams/zh/downtown-atlantis-order.svg',
  sourceId: 'downtown-atlantis-order',
  caption:
    '原创示意图：墙上盒子 → 收音机 → 深色咖啡机 → 白色咖啡机 → 汽水机 → 微波炉 → 冰箱。',
  alt: '墙上盒子 → 收音机 → 深色咖啡机 → 白色咖啡机 → 汽水机 → 微波炉 → 冰箱。',
};
export const quickAnswer =
  '墙上盒子 → 收音机 → 深色咖啡机 → 白色咖啡机 → 汽水机 → 微波炉 → 冰箱。';

## 先确认是市中心餐厅

这里对应 Downtown 的 Atlantis Restaurant。公园同名餐厅使用不同谜题，字母密码不能用于此处。

## 七个物件操作顺序

1. 后方右角的墙上盒子。
2. 从入口看位于左侧的收音机。
3. 柜台上的深色咖啡机。
4. 柜台后货架上的白色咖啡机。
5. 汽水机。
6. 微波炉。
7. 柜台后方角落的冰箱。

## 墙没打开的常见原因

重点检查两台咖啡机：先深色，后白色。确认区域，再按完整顺序操作。

## 完成标志与奖励

隐藏墙打开后进入秘密藏身处，收集生命升级物品。公园另一处答案见 [Atlantis 密码 BDAC](/puzzles/atlantis-code-the-park)。
